import { NavLink, useSearchParams } from "react-router-dom";

import { useSearchPage } from "../../queries/search-page";
import { useLocale } from "../../stores/locale";

export function SearchPageResult() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get("query");
  const t = useLocale((state) => state.locale);

  const { data: pages } = useSearchPage(query ?? "");

  if (!query) {
    throw new Error("No query");
  }

  return (
    <>
      <div className="mb-4 flex items-end justify-between gap-2">
        <h1 className="text-2xl font-bold">
          {t.search.title.replace("{query}", query ?? "")}
        </h1>
        <p className="text-sm text-gray-500">
          {t.search.found.replace("{count}", pages?.length?.toString() ?? "0")}
        </p>
      </div>
      {pages?.length === 0 && (
        <div className="mt-10 flex items-center justify-center">
          <p className="text-lg italic text-gray-500">{t.search.noResults}</p>
        </div>
      )}
      <ul>
        {pages?.map((page) => (
          <li key={page.id}>
            <NavLink
              className="block mb-8 rounded-md border border-gray-200 bg-gray-100 px-4 pb-8 pt-4"
              to={`${page.slug}`}
            >
              <h2 className="text-md font-bold line-clamp-1">{page.title}</h2>
              <div
                className="line-clamp-4"
                dangerouslySetInnerHTML={{
                  __html:
                    page.content
                      ?.replace(/<em>/g, `<em class="underline font-bold">`)
                      .replace(/<\/em>/g, "</em>") ?? "",
                }}
              />
            </NavLink>
          </li>
        ))}
      </ul>
    </>
  );
}
